// extracted by mini-css-extract-plugin
export default {"content-title":"questContent_content-title__u1cX8","content-container":"questContent_content-container__kl7oq","bottom-container":"questContent_bottom-container__d1rSJ"};